module.exports = __webpack_public_path__ + "static/hero-border-white-9d124456bfc816bd5204f6094343f34b.svg";